/*
 * Juego de iconos de la navegacion, cada uno con variante de CONTORNO y variante
 * RELLENA (RNF-022, RNF-023): el destino en curso se distingue por color Y por
 * variante del icono, nunca solo por color.
 *
 * 24 px, como fija RNF-022. El color lo toma de currentColor para respetar los
 * tokens del tema; ningun icono trae color propio.
 */

const TRAZOS = {
  tablero: {
    contorno: 'M4 4h7v7H4V4zm9 0h7v4h-7V4zM4 13h7v7H4v-7zm9 3h7v4h-7v-4zm0-6h7v4h-7v-4z',
    relleno: 'M4 4h7v7H4V4zm9 0h7v4h-7V4zM4 13h7v7H4v-7zm9 3h7v4h-7v-4zm0-6h7v4h-7v-4z',
  },
  movimientos: {
    contorno: 'M4 7h11l-3-3 1.4-1.4L19 8l-5.6 5.4L12 12l3-3H4V7zm16 10H9l3 3-1.4 1.4L5 16l5.6-5.4L12 12l-3 3h11v2z',
    relleno: 'M4 7h11l-3-3 1.4-1.4L19 8l-5.6 5.4L12 12l3-3H4V7zm16 10H9l3 3-1.4 1.4L5 16l5.6-5.4L12 12l-3 3h11v2z',
  },
  cuentas: {
    contorno: 'M3 6.5A2.5 2.5 0 0 1 5.5 4H18a2 2 0 0 1 2 2v1H5.5a.5.5 0 0 0 0 1H20a1 1 0 0 1 1 1v8a2 2 0 0 1-2 2H5.5A2.5 2.5 0 0 1 3 14.5v-8zM17 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
    relleno: 'M3 6.5A2.5 2.5 0 0 1 5.5 4H18a2 2 0 0 1 2 2v1H5.5a.5.5 0 0 0 0 1H20a1 1 0 0 1 1 1v8a2 2 0 0 1-2 2H5.5A2.5 2.5 0 0 1 3 14.5v-8zM17 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
  },
  presupuesto: {
    contorno: 'M12 2 3 12l9 10 9-10-9-10zm0 3.2 6.1 6.8L12 18.8 5.9 12 12 5.2z',
    relleno: 'M12 2 3 12l9 10 9-10-9-10z',
  },
  vencimientos: {
    contorno: 'M7 2h2v2h6V2h2v2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2zM5 9v11h14V9H5z',
    relleno: 'M7 2h2v2h6V2h2v2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2zM5 9v11h14V9H5zm3 2h3v3H8v-3z',
  },
  engrane: {
    contorno: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-1.6-8h3.2l.4 2.3c.5.2 1 .4 1.4.7l2.2-.9 1.6 2.8-1.8 1.5c0 .3.1.5.1.8s0 .5-.1.8l1.8 1.5-1.6 2.8-2.2-.9c-.4.3-.9.5-1.4.7l-.4 2.3h-3.2l-.4-2.3c-.5-.2-1-.4-1.4-.7l-2.2.9-1.6-2.8 1.8-1.5c0-.3-.1-.5-.1-.8s0-.5.1-.8L2.8 5.9l1.6-2.8 2.2.9c.4-.3.9-.5 1.4-.7L10.4 2z',
    relleno: 'M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-1.6-6.5h3.2l.4 2.3c.5.2 1 .4 1.4.7l2.2-.9 1.6 2.8-1.8 1.5c0 .3.1.5.1.8s0 .5-.1.8l1.8 1.5-1.6 2.8-2.2-.9c-.4.3-.9.5-1.4.7l-.4 2.3h-3.2l-.4-2.3c-.5-.2-1-.4-1.4-.7l-2.2.9-1.6-2.8 1.8-1.5c0-.3-.1-.5-.1-.8s0-.5.1-.8L2.8 5.9l1.6-2.8 2.2.9c.4-.3.9-.5 1.4-.7L10.4 2z',
  },
};

export function Icono({ nombre, activo = false, tamano = 24 }) {
  const trazo = TRAZOS[nombre] ?? TRAZOS.engrane;

  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="currentColor"
      stroke={activo ? 'none' : 'currentColor'}
      strokeWidth={activo ? 0 : 0.4}
      opacity={activo ? 1 : 0.9}
    >
      <path d={activo ? trazo.relleno : trazo.contorno} />
    </svg>
  );
}
